import StumpedSVG from './stumped.svg'

type AlertProps = {
  code?: number
}

export const AlertError = ({ code }: AlertProps) => {
  return (
    <div
      className="fixed flex items-center justify-center z-50 inset-0 h-screen overflow-y-hidden bg-white"
      aria-labelledby="modal-title"
      aria-modal="true"
    >
      <div
        className="flex flex-col items-center space-y-4
        
         p-8 w-9/12 text-black
        "
      >
        <img src={StumpedSVG} alt="Problema" className="w-28 h-28" />

        <h2 className="text-4xl font-bold">Temos um problema</h2>

        <span className="text-center text-gray-600">
          Vamos entender o que aconteceu e te ajudar a resolver o problema:
        </span>

        {code === 400 ? (
          <>
            <h3 className="text-red-500 text-lg font-semibold">
              O token que você está tentando utilizar é inválido.
            </h3>

            <p className="text-center text-gray-600">
              Se você acredita que recebeu esse erro por engano, por favor,
              entre em contato com seu RH.
            </p>
          </>
        ) : null}

        {code === 409 ? (
          <>
            <h3 className="text-red-500 text-lg font-semibold">
              O token que você está tentando utilizar já foi utilizado.
            </h3>

            <span className="text-center">
              Caso seja seu primeiro acesso, por favor,{' '}
              <strong>entre em contato com o RH da sua empresa!</strong>
            </span>

            <span className="text-center text-gray-600">
              Se você já fez o acesso, tente fazer o login novamente!
            </span>
          </>
        ) : null}

        {code === 500 ? (
          <>
            <h3 className="text-red-500 text-lg font-semibold">
              Ocorreu um erro interno no nosso servidor. Tente novamente mais
              tarde.
            </h3>

            <span className="text-center text-gray-600">
              Se o erro persistir, por favor, entre em contato com nosso
              suporte.
            </span>
          </>
        ) : null}

        <a
          href="https://virotrip.com.br"
          className="text-white bg-blue rounded-md px-8 uppercase py-2"
        >
          Voltar
        </a>
      </div>
    </div>
  )
}
